/* PB Collections Showcase — click a title to swap bg + card
   Source parity: .pure-brolic-html/script.js #collectionsShowcase
*/
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pbInit === '1') return;
    root.dataset.pbInit = '1';

    var titles = root.querySelectorAll('.pb-showcase__title');
    var bgImages = root.querySelectorAll('.pb-showcase__bg-image');
    var cards = root.querySelectorAll('.pb-showcase-card');
    var cta = root.querySelector('[data-pb-showcase-cta]');

    function setActive(key) {
      var activeTitle = null;
      titles.forEach(function (t) {
        var on = t.getAttribute('data-collection') === key;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) activeTitle = t;
      });
      bgImages.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-collection') === key);
      });
      cards.forEach(function (card) {
        card.classList.toggle('is-active', card.getAttribute('data-collection') === key);
      });
      if (cta && activeTitle) {
        var url = activeTitle.getAttribute('data-collection-url');
        if (url) cta.setAttribute('href', url);
      }
    }

    titles.forEach(function (title) {
      title.addEventListener('click', function () {
        setActive(title.getAttribute('data-collection'));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.pb-showcase').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.pb-showcase');
    if (root) init(root);
  });
})();
